export const generateTicketId = () => {
  const ticket = `${Math.random().toString().substring(2, 5)}${Math.random()
    .toString(36)
    .substring(2, 5)}`.toLocaleUpperCase();
  return `#${ticket}`;
};
